'use client';

import { usePathname } from 'next/navigation';

import {
    Align,
    Box,
    BoxContent,
    Button,
    ButtonVariant,
    DirectionEnum,
    FlexBox,
    GapSize,
    Icon,
    IconName,
    IconSize,
    Justify,
    Text,
    Title,
    TitleLevels,
    TypographyBold,
} from '@bytel/trilogy-react';

import { serverSignIn } from '@actions/get-session';

import { Big } from '@components/big';

import { sendTracking } from '@helpers/tracking';

export function LoginPrompt() {
    const pathName = usePathname();

    const onLogin = async () => {
        sendTracking(false, {
            action: 'Clic_redirection',
            name: 'Bouton_me_connecter',
            category: 'Bloc_deja_client',
        });
        await serverSignIn(pathName);
    };

    return (
        <Box shadowless backgroundSrc='/statics/ecommerce/pattern.webp' radius='md' padding='sm'>
            <BoxContent>
                <Box shadowless radius='md' padding='lg'>
                    <BoxContent>
                        <FlexBox
                            justify={Justify.CENTER}
                            align={Align.CENTER}
                            gap={{ mobile: GapSize.FOUR, tablet: GapSize.FIVE }}
                            direction={{ mobile: DirectionEnum.COLUMN, tablet: DirectionEnum.ROW }}
                        >
                            <Icon name={IconName.USER} size={IconSize.LARGE} className='is-hidden-mobile' />
                            <FlexBox
                                direction={DirectionEnum.COLUMN}
                                align={{ mobile: Align.CENTER }}
                                gap={GapSize.TWO}
                            >
                                <FlexBox align={Align.CENTER}>
                                    <Icon name={IconName.USER} size={IconSize.MEDIUM} className='is-hidden-tablet' />
                                    <Title level={TitleLevels.FOUR} marginless>
                                        Déjà client&nbsp;?
                                    </Title>
                                </FlexBox>
                                <Text
                                    marginless
                                    typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                                    className='has-text-centered-mobile'
                                >
                                    On vous montre vos <Big /> économies&nbsp;!
                                </Text>
                            </FlexBox>
                            <Button
                                data-cy='incentive-block-disconnected-button'
                                onClick={onLogin}
                                type='button'
                                variant={ButtonVariant.PRIMARY}
                                className='is-marginless'
                            >
                                Me connecter
                            </Button>
                        </FlexBox>
                    </BoxContent>
                </Box>
            </BoxContent>
        </Box>
    );
}
